export default __webpack_public_path__ + "static/media/Icono16.55dcada4.svg";